export function substitutedCoefficientLatex(value) {
  return Number(value) < 0 ? `(${value})` : String(value);
}

export function squaredSubstitutedCoefficientLatex(value) {
  return `${substitutedCoefficientLatex(value)}^2`;
}

export function discriminantSubstitutionLatex(a, b, c, discriminant) {
  return `${squaredSubstitutedCoefficientLatex(b)}-4\\cdot ${substitutedCoefficientLatex(a)}\\cdot ${substitutedCoefficientLatex(c)}=${discriminant}`;
}
